export default __webpack_public_path__ + "images/03975f9ea40271dea1b483cfae5eb207-film_and_media.webp";